export default "__VITE_ASSET__xDl5hRfA__"